import styled from 'styled-components';
import { PrimaryButtonComponent } from '../../../../CommonComponents/commonStyles';

export const Arrow = styled.div`
  display: inline-block;
  position: relative;
  left: 10px;
  bottom: 2px;
  transition: left 0.2s;

  @media only screen and (max-width: 990px) {
    left: 5px;
  }
  @media only screen and (max-width: 576px) {
    left: 5px;
  }
`;

export const PillAnchor = styled.button`
  margin-top: ${props => props.cardType ? '20px' : '0'};
  outline: none;
  width: 148px;
  height: 30px;
  background-color: ${props => props.notClickable ? props.theme.backgroundColor.summaryDivider : props.theme.backgroundColor.pill};
  border: solid 1px ${props => props.theme.border.pill};
  border-radius: 1rem;
  cursor: ${props => (props.notClickable ? 'not-allowed' : 'pointer')};
  span {
    font-family: ${props => props.theme.fontFamily.helveticaNeueMedium};
    font-size: ${props => props.theme.fontSize.secondary};
    color: ${props =>
      props.notClickable ? props.theme.fontColors.textColor : props.theme.fontColors.primary};
    padding-left: 0.25rem;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
  }
`;

export const LeftArrow = styled.div`
  padding-top: 1px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  right: 10px;
  -webkit-transition: right 0.2s;
  transition: right 0.2s;
  @media only screen and (max-width: 990px) {
    right: 5px;
  }
  @media only screen and (max-width: 576px) {
    right: 5px;
  }
`;

export const PrimaryButtonWrapper = styled(PrimaryButtonComponent)`
  & > span {
    width: auto;
  }
  &:disabled {
    background-color: #d9d9d9;
  }
  &.ant-btn {
    border-radius: 0px;
    .anticon {
      transition: left 0.2s;
    }
  }
  transition: left 0.2s linear;
  &:hover {
    background-color: #167f91;
  }
  &:hover ${Arrow} {
    left: 20px;
    transition: left 0.2s;
  }
  &:hover ${LeftArrow} {
    right: 20px;
    transition: right 0.2s;
  }
  @media only screen and (max-width: 990px) {
    &:hover ${Arrow} {
      left: 10px;
      transition: left 0.2s;
    }
    &:hover ${LeftArrow} {
      left: 10px;
      transition: right 0.2s;
    }
  }
  @media only screen and (max-width: 576px) {
    &:hover ${Arrow} {
      left: 10px;
      transition: left 0.2s;
    }
    &:hover ${LeftArrow} {
      left: 10px;
      transition: right 0.2s;
    }
  }
`;

export const LazyWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 30px;
  width: 194px;
  background-color: #ffffff;
  border-radius: 18px;
  padding: 7px 12px;
  cursor: pointer;
  border: 1px solid #d4d4d4;
`;

export const BtnDetail = styled.span`
  color: ${props => props.theme.fontColors.primary};
  font-size: 14px;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  cursor: pointer;
  font-weight: 500;
`;

export const LazyCount = styled.span`
  width: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 20px;
  font-size: 12px;
  color: #ffffff;
  border-radius: 10px;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  background-color: ${props => props.theme.fontColors.primary};
`;

export const PillButton = styled.p`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  color: ${props => props.theme.colors.primaryColor};
  font-size: ${props => props.theme.fontSize.primary};
  text-decoration: underline;
  display: inline-block;
  cursor: pointer;
`;
